// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/127: the attempt trail in the transcript. Shaped like the other runtime
   cards (AgentDatasetCandidatesCard) so a failure reads as part of the same
   conversation, not as a debugger. */
.CIh2YLaAHGrJAFF9GX4N {
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  background: var(--curio-card-bg);
  overflow: hidden;
  margin-top: 6px;
}

.eUIL02UK7NWAItBFPNrM {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  border-bottom: 1px solid var(--curio-border);
}

.uA1CogPNYFe1xMW3c6FC {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--curio-warning-text);
}

.ciRMxizgsD2aEzDXw8AY {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.OwAmMSLgy3fcR6fbWT64 {
  margin-left: auto;
  font-weight: 500;
  color: var(--curio-text-secondary);
  font-size: 0.72rem;
  white-space: nowrap;
}

.t4SQn2mAyVjc8D90nHMA {
  list-style: none;
  margin: 0;
  padding: 4px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.QHc4viHqc_5WutA8mkJs {
  cursor: pointer;
  font-size: 0.74rem;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: baseline;
}

.zDsAjrVZiQh4RjT7YQLA {
  font-weight: 600;
}

.dqaj1StuRrL4mmh8B8Al {
  color: var(--curio-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
}

.THTiFKC58V8HuXynYebS {
  margin: 4px 0;
  font-size: 0.73rem;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--curio-warning-text);
}

.QB316h07rcOqxPyrdJQg {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-secondary);
  margin: 4px 0 2px;
}

.P2O07ghZR8D67LeuTyw_ {
  margin: 2px 0 6px;
  font-size: 0.74rem;
  white-space: pre-wrap;
  color: var(--curio-text-primary);
}

.VjZaqGY4qLhVcBUCA4n2,
.vmCOzN7XMDPK8AemELiH {
  padding: 4px 10px 8px;
  font-size: 0.72rem;
  color: var(--curio-text-secondary);
}

.bJb8b_2aJCXrhy1MbQ2w {
  font-size: 0.76rem;
  font-weight: 600;
  border-radius: 8px;
  padding: 4px 12px;
  cursor: pointer;
  border: 1px solid var(--curio-border-strong);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
}

.bJb8b_2aJCXrhy1MbQ2w:hover {
  border-color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentSolveAttemptsCard.module.css"],"names":[],"mappings":"AAAA;;qCAEqC;AACrC;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":["/* dev/127: the attempt trail in the transcript. Shaped like the other runtime\n   cards (AgentDatasetCandidatesCard) so a failure reads as part of the same\n   conversation, not as a debugger. */\n.card {\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  background: var(--curio-card-bg);\n  overflow: hidden;\n  margin-top: 6px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.accentDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--curio-warning-text);\n}\n\n.title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kind {\n  margin-left: auto;\n  font-weight: 500;\n  color: var(--curio-text-secondary);\n  font-size: 0.72rem;\n  white-space: nowrap;\n}\n\n.rows {\n  list-style: none;\n  margin: 0;\n  padding: 4px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.summary {\n  cursor: pointer;\n  font-size: 0.74rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: baseline;\n}\n\n.round {\n  font-weight: 600;\n}\n\n.errorHead {\n  color: var(--curio-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.error {\n  margin: 4px 0;\n  font-size: 0.73rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--curio-warning-text);\n}\n\n.codeLabel {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-secondary);\n  margin: 4px 0 2px;\n}\n\n.prose {\n  margin: 2px 0 6px;\n  font-size: 0.74rem;\n  white-space: pre-wrap;\n  color: var(--curio-text-primary);\n}\n\n.note,\n.actions {\n  padding: 4px 10px 8px;\n  font-size: 0.72rem;\n  color: var(--curio-text-secondary);\n}\n\n.open {\n  font-size: 0.76rem;\n  font-weight: 600;\n  border-radius: 8px;\n  padding: 4px 12px;\n  cursor: pointer;\n  border: 1px solid var(--curio-border-strong);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n}\n\n.open:hover {\n  border-color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CIh2YLaAHGrJAFF9GX4N`,
	"header": `eUIL02UK7NWAItBFPNrM`,
	"accentDot": `uA1CogPNYFe1xMW3c6FC`,
	"title": `ciRMxizgsD2aEzDXw8AY`,
	"kind": `OwAmMSLgy3fcR6fbWT64`,
	"rows": `t4SQn2mAyVjc8D90nHMA`,
	"summary": `QHc4viHqc_5WutA8mkJs`,
	"round": `zDsAjrVZiQh4RjT7YQLA`,
	"errorHead": `dqaj1StuRrL4mmh8B8Al`,
	"error": `THTiFKC58V8HuXynYebS`,
	"codeLabel": `QB316h07rcOqxPyrdJQg`,
	"prose": `P2O07ghZR8D67LeuTyw_`,
	"note": `VjZaqGY4qLhVcBUCA4n2`,
	"actions": `vmCOzN7XMDPK8AemELiH`,
	"open": `bJb8b_2aJCXrhy1MbQ2w`
};
export default ___CSS_LOADER_EXPORT___;
